import { Injectable } from '@angular/core';
import { ApiService, ApiCacheOptions, PagedSearch } from '../../shared/index';
import { MembershipActivityRow } from './membership-activity-row.model';
import { RetentionRow } from './retention-row.model';
import { MonthlyAddDrops } from './monthly-add-drops.interface';
import { DashboardReportDto } from './dashboard-report.dto';
import { DashboardReportSearchDto } from './dashboard-report-search.dto';
import { PagedResult } from 'src/app/shared/model/generic-paged-result.model';

@Injectable()
export class DashboardService {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getMembershipActivityReport(startDate: Date, endDate: Date): Promise<Array<MembershipActivityRow>> {
    if (!startDate || !endDate) {
      return Promise.resolve([]);
    }

    let url = 'Dashboard/MembershipActivity?StartDate=' + startDate.toDateString() + '&EndDate=' + endDate.toDateString();
    return this._apiService.get(url, this._cacheOptions);
  }

  public getRetentionReport(startDate: Date | undefined, endDate: Date | undefined): Promise<Array<RetentionRow>> {
    if (!startDate || !endDate) {
      return Promise.resolve([]);
    }

    const url = 'Dashboard/Retention?StartDate=' + startDate.toDateString() + '&EndDate=' + endDate.toDateString();
    return this._apiService.get(url, this._cacheOptions);
  }

  public getMonthlyAddDropReport(startDate: Date, endDate: Date): Promise<MonthlyAddDrops[]> {
    if (!startDate || !endDate) {
      return Promise.resolve([]);
    }

    let url = `Dashboard/MonthlyAddDrop?StartDate=${startDate.toDateString()}&EndDate=${endDate.toDateString()}`;
    return this._apiService.get(url, this._cacheOptions);
  }

  public searchDashboardReports(search: DashboardReportSearchDto): Promise<PagedResult<DashboardReportDto>> {
    return this._apiService.postPaged('Dashboard/Reports/Search', search);
  }
}
